<template>
  <!-- TODO: replace me with a  -->
  <button
    role="button"
    class="group size-11 flex items-center justify-center rounded bg-surface transition cursor-pointer border border-current-border hover:border-current relative"
    :aria-label="$t('Shopping cart')">
    <ShoppingCartIcon class="h-5 group-hover:scale-105 transition-transform" />
    <div
      v-if="count"
      class="absolute -top-2 -right-1.5 font-bold bg-red-600 text-white flex justify-center items-center rounded-full size-5 px-1 border-2 border-surface"
      style="font-size: 12px">
      {{ count }}
    </div>
  </button>
</template>

<script setup>
defineProps({
  count: { required: true },
  items: { required: true },
});
import { ShoppingCartIcon } from "@heroicons/vue/24/outline";
</script>

<style scoped></style>
